import React, { useEffect, useRef, useState } from "react";
import Container from "../components/Container";
import { useDispatch, useSelector } from "react-redux";
 import  {  getAllProducts } from "../features/products/productSlice";
import {  Link, useNavigate } from "react-router-dom";
 import { useMediaQuery } from "react-responsive";
import "react-multi-carousel/lib/styles.css";
 import Meta from "../components/Meta";

import {  Row, Col } from "reactstrap";
  
import HeroSlider from "../components/HeroSlider";
import FindCarForm from "../components/FindCarForm";
import "../styles/find-car-form.css";
import "../styles/filter-wrapper.css";
import "../styles/elementor.css";


 import logo2 from "../images/brands/bmw.svg"
import logo3 from "../images/brands/audi.svg"
import logo4 from "../images/brands/mercedes.svg"
import logo5 from "../images/brands/honda.svg"
import logo6 from "../images/brands/hyundai.svg"
import logo7 from "../images/brands/land_rover.svg"
import logo8 from "../images/brands/lexus.svg"
import logo9 from "../images/brands/mazda.svg"
import logo10 from "../images/brands/nissan.svg"
import logo11 from "../images/brands/VW.svg"
import logo12 from "../images/brands/subaru.svg"
import logo13 from "../images/brands/toyota.svg"

import body1 from "../images/body/suv.svg"
import body2 from "../images/body/wagon.svg"
import body3 from "../images/body/hatchback.svg"
import body4 from "../images/body/sedan.svg"
import body5 from "../images/body/van.svg"
import body6 from "../images/body/coupe.svg"
import body7 from "../images/body/crossover.svg"
import body8 from "../images/body/truck.svg"

import usage1 from "../images/usage/uber.svg"
import usage2 from "../images/usage/matatu.svg"
import usage3 from "../images/usage/family.svg"
import usage4 from "../images/usage/off-road.svg"
import usage5 from "../images/usage/racing.svg"
import usage6 from "../images/usage/goods.svg"

 
import NewArrivals from "../components/NewArrivals";
import WhatsappChat from "../components/WhatsappChat";
 import { IoCarSportOutline } from "react-icons/io5";
import { PiChatsDuotone } from "react-icons/pi";
import { IoKeyOutline } from "react-icons/io5";
import { FaRegCreditCard } from "react-icons/fa";
 import Testimonial from "../components/Testimonial";
import { CiFilter } from "react-icons/ci";
import { HiOutlineViewGrid } from "react-icons/hi";
import { PiVan } from "react-icons/pi";
import AboutUs from "../components/AboutUs";
import Counter from "../components/Counter";
import WhyChooseUs from "../components/WhyChooseUs";
import Blogs from "./Blogs";
import BlogsSection from "../components/BlogsSection";
import OurServices from "../components/OurServices";

function countWords(text) {
  return text.split(/\s+/).filter(word => word !== '').length;
}

const Home = () => {
   const productState = useSelector((state) => state.product.product);
  const navigate=useNavigate()
 

  const dispatch = useDispatch();
  useEffect(() => {
    
    getallProducts();
   
  }, []);
  
  const getallProducts = () => {
    dispatch(getAllProducts());
  };

 

  const [activeFilter, setActiveFilter] = useState("advanced");

  return (
    <>
 
<Meta 
  title="Matel Trading Motors" 
  description="Matel Trading Motors is your trusted partner for high-quality new and used vehicles in Kenya. We offer a wide range of cars, both locally available and imported from Japan, Thailand, the UK, and Singapore, with flexible financing options to suit your needs." 
  keywords="Matel Trading Motors, car dealership Kenya, buy used cars Kenya, new cars Kenya, vehicle import Kenya, imported cars, car financing Kenya, reliable car dealers" 
/>

 
      <section className="p-0  hero__slider-section">
      
        <HeroSlider />

        <div className="hero__form ">
          <div className="hero__form-container">
            <Row className="form__row">
        
               <div>
                </div>
            </Row>
          </div>
        </div>
      </section>



      <div className="home-wrapper main-filter-wrapper">
      
      <div className="filter-main-header">
        <h1>Discover Cars That Match Your Needs</h1>
        <p>Browse our wide selection of vehicles by brand, body type, or advanced filters.</p>

      </div>
      <nav>
          <ul>
              <li
              className={activeFilter === "advanced" ? "active" : ""}
              onClick={() => setActiveFilter("advanced")}
            >
            <CiFilter className="filter__icon" /> Advanced Filter
            </li>          
            <li
              className={activeFilter === "brand" ? "active" : ""}
              onClick={() => setActiveFilter("brand")}
            >
             <HiOutlineViewGrid className="filter__icon"/> Brand
            </li>
            
            <li
              className={activeFilter === "body" ? "active" : ""}
              onClick={() => setActiveFilter("body")}
            >
             <PiVan className="filter__icon"/> Body Type
            </li>

          </ul>
        </nav>
     {activeFilter === "advanced" && (
      <div className="advanced__search-wrapper">
      <FindCarForm/>
      </div>
      
     )}      
 
{activeFilter === "brand" && (
  <div className="filter-categories-container">
    <Link to="/brand/bmw" className="filter-card">
      <img src={logo2} title="logo" loading="lazy" alt="logo image" />
      <span>BMW</span>
    </Link>

    <Link to="/brand/audi" className="filter-card">
      <img src={logo3} title="logo" loading="lazy" alt="logo image" />
      <span>Audi</span>
    </Link>

    <Link to="/brand/mercedes" className="filter-card">
      <img src={logo4} title="logo" loading="lazy" alt="logo image" />
      <span>Mercedes</span>
    </Link>

    <Link to="/brand/honda" className="filter-card">
      <img src={logo5} title="logo" loading="lazy" alt="logo image" />
      <span>Honda</span>
    </Link>

    <Link to="/brand/volkswagen" className="filter-card">
      <img src={logo11} title="logo" loading="lazy" alt="logo image" />
      <span>Volkswagen</span>
    </Link>

  
 

    <Link to="/brand/mazda" className="filter-card">
      <img src={logo9} title="logo" loading="lazy" alt="logo image" />
      <span>Mazda</span>
    </Link>
    <Link to="/brand/subaru" className="filter-card">
      <img src={logo12} title="logo" loading="lazy" alt="logo image" />
      <span>Subaru</span>
    </Link>
    <Link to="/brand/nissan" className="filter-card">
      <img src={logo10} title="logo" loading="lazy" alt="logo image" />
      <span>Nissan</span>
    </Link>

    <Link to="/brand/toyota" className="filter-card">
      <img src={logo13} title="logo" loading="lazy" alt="logo image" />
      <span>Toyota</span>
    </Link>
  </div>
)}


       {activeFilter === "usage" && (
       <div className="filter-usage-container">
   

   <Link to="/usage/uber" className="filter-card">
    <img src={usage1} title="logo" loading="lazy" alt="logo image"/>
     <span>Uber</span>
   </Link>

   <Link to="/usage/matatu" className="filter-card">
    <img src={usage2} title="logo" loading="lazy" alt="logo image"/>
     <span>Matatu</span>
   </Link>

   <Link  to="/usage/family-car" className="filter-card">
    <img src={usage3} title="logo" loading="lazy" alt="logo image"/>
   <span>Family Car</span>
   </Link>

 

   <Link to="/usage/off-road-car" className="filter-card">
    <img src={usage4} title="logo" loading="lazy" alt="logo image"/>
     <span>Off-road Car</span>
   </Link>

   <Link to="/usage/racing" className="filter-card">
    <img src={usage5} title="logo" loading="lazy" alt="logo image"/>
    <span>Racing</span>
   </Link>
   <Link to="/usage/goods-and-transport" className="filter-card">
    <img src={usage6} title="logo" loading="lazy" alt="logo image"/>
    <span>Goods And Transport</span>
   </Link>   
 
 
 
 </div>
  )}

     
       {activeFilter === "body" && (
       <div className="filter-body-container">
   

   <Link to="/suv" className="filter-card">
    <img src={body1} title="logo" loading="lazy" alt="logo image"/>
     <span>Suv</span>
   </Link>

   <Link to="/convertible" className="filter-card">
    <img src={body2} title="logo" loading="lazy" alt="logo image"/>
     <span>Wagon</span>
   </Link>

   <Link  to="/hatchback" className="filter-card">
    <img src={body3} title="logo" loading="lazy" alt="logo image"/>
   <span>Hatchback</span>
   </Link>

   <Link to="/saloon" className="filter-card">
    <img src={body4} title="logo" loading="lazy" alt="logo image"/>
     <span>Saloon</span>
   </Link>

   <Link to="/van" className="filter-card">
    <img src={body5} title="logo" loading="lazy" alt="logo image"/>
     <span>Van</span>
   </Link>

   <Link to="/coupe" className="filter-card">
    <img src={body6} title="logo" loading="lazy" alt="logo image"/>
    <span>Coupe</span>
   </Link>

      <Link to="/crossover" className="filter-card">
    <img src={body7} title="logo" loading="lazy" alt="logo image"/>
     <span>CrossOver</span>
   </Link>

   <Link to="/truck" className="filter-card">
    <img src={body8} title="logo" loading="lazy" alt="logo image"/>
     <span>Truck</span>
   </Link>
 
 
 </div>
  )}
     

       

      </div>


 
      <Container class1="home-wrapper-1 mt-3 mb-3 py-2 main-wrapper" >
        <div className="featured-wrapper-el ">

         <NewArrivals/>
        </div>
      </Container>
     <OurServices/>  
    <AboutUs/>

    <Counter/>
 
    
        <div className="mt-5 choose__us-section">
        <WhyChooseUs/>
        </div>
         <Testimonial/>
         <BlogsSection/>
    </>
  );
};

export default Home;
